{
  "DATA_ASSISTANT": {
    "TITLE": "Data-assistent",
    "NEW_CONVERSATION": "+ Nieuw",
    "LOADING": "Laden...",
    "LOADING_MESSAGES": "Berichten laden...",
    "THINKING": "Aan het denken...",
    "UNTITLED": "Naamloos gesprek",
    "NO_CONVERSATIONS": "Nog geen gesprekken. Klik op \"+ Nieuw\" om te beginnen.",
    "EMPTY_STATE": "Selecteer een gesprek of maak een nieuw gesprek aan om te beginnen.",
    "PLACEHOLDER": "Wat kan ik voor je uitzoeken?",
    "SHOW_SQL": "SQL tonen",
    "NO_ROWS": "Geen rijen gevonden.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Gesprek verwijderen",
    "DELETE_CONFIRM_DESCRIPTION": "Weet je zeker dat je dit gesprek wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
    "DELETE_CONFIRM_YES": "Verwijderen",
    "REPORTS": "Rapporten",
    "SAVE_TO_REPORT": "Opslaan in rapport",
    "NEW_REPORT": "Nieuw rapport",
    "REPORT_NAME": "Rapportnaam",
    "NO_REPORTS": "Nog geen opgeslagen rapporten",
    "REPORTS_EMPTY_STATE": "Selecteer een rapport of maak een nieuw rapport aan.",
    "REPORT_SAVED": "Opgeslagen in rapport",
    "DELETE_REPORT_CONFIRM": "Rapport verwijderen",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Weet je zeker dat je dit rapport wilt verwijderen? Alle opgeslagen items worden verwijderd.",
    "DELETE_ITEM_CONFIRM": "Item verwijderen",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Weet je zeker dat je dit item uit het rapport wilt verwijderen?",
    "EXPORT_CSV": "CSV exporteren",
    "REFRESH": "Vernieuwen",
    "QUERY_RUNNING": "Query wordt uitgevoerd...",
    "QUERY_FAILED": "Query mislukt",
    "AUTO_REFRESH": "Automatisch vernieuwen",
    "AUTO_REFRESH_NONE": "Handmatig",
    "AUTO_REFRESH_30S": "30 seconden",
    "AUTO_REFRESH_1M": "1 minuut",
    "AUTO_REFRESH_5M": "5 minuten",
    "AUTO_REFRESH_10M": "10 minuten",
    "EDIT_MESSAGE": "Bericht bewerken",
    "RENAME_REPORT": "Rapport hernoemen",
    "RENAME_ITEM": "Item hernoemen",
    "MOVE_UP": "Omhoog verplaatsen",
    "MOVE_DOWN": "Omlaag verplaatsen",
    "COLLABORATORS": {
      "BUTTON": "Samenwerkers",
      "TITLE": "Samenwerkers van rapport",
      "DESCRIPTION": "Kies welke agenten en teams dit rapport mogen bekijken.",
      "AGENTS": "Agenten",
      "TEAMS": "Teams",
      "SELECT_AGENTS": "Selecteer agenten",
      "SELECT_TEAMS": "Selecteer teams",
      "SAVE": "Opslaan",
      "SAVED": "Samenwerkers bijgewerkt",
      "SAVE_FAILED": "Bijwerken van samenwerkers mislukt"
    }
  }
}
